import axios from 'axios'
import { useEffect, useState, useCallback } from 'react'

const ENDPOINT = `https://www.cabiweb.dk/umbraco/api/taxonomyapi/GetEmployeeTaxonomy`

type Response =
  | { status: 'initial' }
  | { status: 'loading'; result: ReadonlyArray<{ label: string; value: string }> }
  | { status: 'error'; error: Error }
  | { status: 'ok'; result: ReadonlyArray<{ label: string; value: string }> }

export const useSubjects = (): [Response, () => void] => {
  const [state, setState] = useState<Response>({ status: 'initial' })

  const getSubjects = useCallback(async () => {
    setState((state) => ({
      status: 'loading',
      result: state.status === 'ok' ? state.result : []
    }))

    try {
      const response = await axios.get(ENDPOINT)
      const result: ReadonlyArray<{ label: string; value: string }> = response.data.SubjectAreas.Tags.map(
        ({ Id, Name }: any) => ({
          label: Name,
          value: `${Id}`
        })
      )

      setState({ status: 'ok', result })
    } catch (error) {
      setState({ status: 'error', error })
    }
  }, [])

  useEffect(() => {
    getSubjects()
  }, [getSubjects])

  return [state, getSubjects]
}
